import { bytesToHex, hexToBytes } from './hex';
export * from './hex';

import { ed25519 } from './ed25519'
import { secp256k1 } from './secp256k1'
export { ed25519, secp256k1 };

export async function encrypt(
  publicKeyHex: string,
  message: string
): Promise<Uint8Array> {
  const len = hexToBytes(publicKeyHex).length;
  if (len === 32) return ed25519.encrypt(publicKeyHex, message);
  if (len === 33) return secp256k1.encrypt(publicKeyHex, message);
  throw new Error('Unknown public key type');
}

export async function encryptAsHex(
  publicKeyHex: string,
  message: string
): Promise<string> {
  return bytesToHex(await encrypt(publicKeyHex, message));
}

export async function encryptAsHexWithCasperPublicKey(
  publicKeyHex: string,
  message: string
): Promise<string> {
  return encryptAsHex(publicKeyHex.slice(2), message);
}

export async function decryptEncryptedHexWithPem(
  privateKeyPem: string,
  encryptedHex: string
): Promise<string> {
  if (privateKeyPem.includes('BEGIN EC PRIVATE KEY')) {
    return secp256k1.decryptWithPem(privateKeyPem, hexToBytes(encryptedHex));
  }

  return ed25519.decryptWithPem(privateKeyPem, hexToBytes(encryptedHex));
}

// @ts-ignore
window.chainmail = {
  encrypt,
  encryptAsHex,
  encryptAsHexWithCasperPublicKey,
  decryptEncryptedHexWithPem
};